import apis from '@/utils/apis';

export default {
  methods: {
    // 如果是退款账单，应付金额要格式化为负数
    formatRefundBill(list, key = 'paymentAmount') {
      return list.map((item) => {
        const ret = {
          ...item,
        };
        if (item.isRefundBill) {
          const amount = item[key] || 0;
          ret[key] = Math.abs(amount) * -1;
        }

        return ret;
      });
    },
    // 格式化attachs数据，与新增付款信息时保持一致
    formatAttachs(list) {
      list.forEach((item) => {
        if (!item.attachUrl) {
          item.attachUrl = item.attachPath;
          item.attachPath = this.$formatAttachPath(item.attachPath);
        }
      });
      return list;
    },
    getPaymentInfoReqUrl(row) {
      const paymentCode = row.paymentCode || row.billPaymentCode;
      const paymentId = row.billPaymentId || row.paymentId;
      const billId = row.billId;
      if (billId) {
        return `${apis.paymentPaymentInfo}/${billId}`;
      }
      if (paymentCode) {
        return `${apis.paymentInfoByCode}/${paymentCode}`;
      }
      if (paymentId) {
        return `${apis.paymentPaymentInfoById}/${paymentId}`;
      }
      return '';
    },
  },
};
